<template>
  <p class="-xstb">OrgManagement Component</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>